import { Modal } from 'bootstrap';
import '../sass/film.sass';

declare const Routing: any;

async function checkWidevineLevel(level: string, robustness: string) {
    const config = [{
        videoCapabilities: [{
            contentType: 'video/webm; codecs="vp09.00.10.08"',
            robustness
        }]
    }];

    try {
        await navigator.requestMediaKeySystemAccess('com.widevine.alpha', config);
        console.log(`✅ Widevine ${level} supported`);
        return true;
    } catch (e) {
        console.log(`❌ Widevine ${level} not supported`);
        return false;
    }
}

async function checkPlayReadySL3000Support() {
    const config: MediaDecodingConfiguration = {
        type: 'media-source',
        video: {
            contentType: 'video/mp4; codecs="avc1.4d401f"', // H.264 High@L4.1
            width: 1920,
            height: 1080,
            bitrate: 2000000,
            framerate: 30
        },
        // @ts-ignore
        keySystemConfiguration: {
            keySystem: 'com.microsoft.playready.recommendation.3000', // SL3000 key system
            persistentStateRequired: 'required',
            video: {
                robustness: '' // Robustness is enforced by the key system itself
            }
        }
    };

    try {
        const result = await navigator.mediaCapabilities.decodingInfo(config) as any;
        if (result.supported && result.keySystemAccess) {
            console.log('✅ PlayReady SL3000 (Hardware DRM) is supported.');
            return true;
        } else {
            console.log('❌ PlayReady SL3000 is not supported.');
            return false;
        }
    } catch (error) {
        console.error('Error checking PlayReady SL3000 support:', error);
        return false;
    }
}

document.addEventListener("DOMContentLoaded", async () => {
    const supportsWidevineL1 = await checkWidevineLevel('L1', 'HW_SECURE_ALL');
    // const supportWidevineL2 = checkWidevineLevel('L2', 'HW_SECURE_CRYPTO');
    const supportsWidevineL3 = await checkWidevineLevel('L3', 'SW_SECURE_CRYPTO');
    const supportsHardwarePlayready = await checkPlayReadySL3000Support();

    const rentBtn = document.querySelector<HTMLAnchorElement>("a#rent-time-film-btn");
    const buyBtn = document.querySelector<HTMLAnchorElement>("a#buy-film-btn");
    const watchBtn = document.querySelector<HTMLAnchorElement>("a#watch-film-btn");
    const giftAllBtn = document.querySelector<HTMLAnchorElement>("a#gift-all-film-btn");
    const giftAllSvodBtn = document.querySelector<HTMLAnchorElement>("a#gift-all-svod-btn");
    const giftRentBtn = document.querySelector<HTMLAnchorElement>("a#gift-rent-time-film-btn");
    const giftBuyBtn = document.querySelector<HTMLAnchorElement>("a#gift-buy-film-btn");

    /**
     * Récupère le HTML du produit via `fetch`
     */
    const optionFilm = async (
        type: string,
        filmId: string | null,
        parameters?: string
    ): Promise<string> => {
        let requestUrl: string;

        if (type === "svod") {
            requestUrl = Routing.generate("uc_fo_show_product_svod");
        } else {
            requestUrl = Routing.generate("uc_fo_videoproduction_show_product_film_all", {
                film: filmId,
            });
        }

        if (parameters) {
            requestUrl += (requestUrl.includes("?") ? "&" : "?") + parameters;
        }

        const response = await fetch(requestUrl, { method: "GET" });

        if (!response.ok) {
            throw new Error(`Erreur HTTP ${response.status}`);
        }

        return response.text();
    };

    /**
     * Active les boutons dans la modale (submit le formulaire)
     */
    const sendItem = (): void => {
        const buttons = document.querySelectorAll<HTMLButtonElement>(
            "#form-option-film button"
        );

        buttons.forEach((button) => {
            button.addEventListener("click", (e) => {
                e.preventDefault();
                const item = button.dataset.item;
                const input = document.getElementById("product-item") as HTMLInputElement | null;
                const form = document.getElementById("form-option-film") as HTMLFormElement | null;

                if (item && input && form) {
                    input.value = item;
                    form.submit();
                }
            });
        });
    };

    /**
     * Gestion des clics sur les boutons d’action (achat, location, etc.)
     */
    const handleFilmClick = (
        type: string,
        filmBtn: HTMLAnchorElement | null,
        isGift: boolean = false
    ): void => {
        if (!filmBtn) return;

        filmBtn.addEventListener("click", async (e) => {
            e.preventDefault();

            const filmId = filmBtn.dataset.filmId ?? null;
            const params = isGift ? "gift=true" : undefined;

            try {
                const html = await optionFilm(type, filmId, params);

                if (type === "rent" && !isGift) {
                    // Modale principale déjà dans le DOM
                    const modalElement = document.getElementById("mainModal");
                    if (!modalElement) return;

                    const body = modalElement.querySelector(".modal-body");
                    if (body) body.innerHTML = html;

                    if (!supportsWidevineL1 && supportsWidevineL3 && !supportsHardwarePlayready) {
                        // (body.querySelector('#js-drm-warning') as HTMLElement).style.display = 'inline-block';
                    }

                    const modal = Modal.getOrCreateInstance(modalElement);
                    modal.show();

                    modalElement.addEventListener("shown.bs.modal", sendItem, { once: true });
                    modalElement.querySelector('[data-dismiss="modal"]').addEventListener("click", () => {
                        modal.hide();
                    });
                } else {
                    // Création dynamique d'une modale Bootstrap
                    const modalContainer = document.createElement("div");
                    modalContainer.classList.add("modal", "fade");
                    modalContainer.tabIndex = -1;
                    modalContainer.innerHTML = `
            <div class="modal-dialog modal-lg modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" style="position: absolute;right: 20px;top: 18px;" data-dismiss="modal">
                    <svg style="cursor: pointer;transform: rotate(45deg)" xmlns="http://www.w3.org/2000/svg" version="1.1" width="25" height="25" viewBox="0 0 25 25">
                      <defs>
                        <style>
                          .st0 {
                            fill: none;
                            stroke: #fff;
                            stroke-linecap: round;
                            stroke-width: 4px;
                          }
                        </style>
                      </defs>
                      <path class="st0" d="M12.5,1.2v22.5"/>
                      <path class="st0" d="M23.8,12.5H1.2"/>
                    </svg>
                  </button>
                </div>
                <div class="modal-body">${html}</div>
              </div>
            </div>
          `;

                    document.body.appendChild(modalContainer);

                    const modal = new Modal(modalContainer);
                    modal.show();

                    modalContainer.addEventListener("shown.bs.modal", sendItem, { once: true });
                    modalContainer.addEventListener("hidden.bs.modal", () => modalContainer.remove(), {
                        once: true,
                    });
                    modalContainer.querySelector('[data-dismiss="modal"]').addEventListener("click", () => {
                        modal.hide();
                    });
                }
            } catch (err) {
                console.error("Erreur lors du chargement du film :", err);
            }
        });
    };

    // Activation des handlers
    handleFilmClick("rent", rentBtn);
    handleFilmClick("buy", buyBtn);
    handleFilmClick("watch", watchBtn);
    handleFilmClick("all", giftAllBtn, true);
    handleFilmClick("svod", giftAllSvodBtn, true);
    handleFilmClick("rent", giftRentBtn, true);
    handleFilmClick("buy", giftBuyBtn, true);
});
